export const enum EmailEndpoints {
  MultipleEmails = 'email',
  SingleEmail = 'email/{{0}}',
  SendEmail = 'email/{{0}}/send',
}
